 const getters = {
     userId: state => state.user.userId,
     userName: state => state.user.userName,
     token_: state => state.user.token_,
     permission_: state => state.permission.routers,
     sidebar: state => state.app.sidebar,
 }
 export default getters